import { IconButton, Tooltip } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import CapabilityBoundary from "../../components/CapabilityBoundary/CapabilityBoundary";
import CAPABILITIES from "../../capabilities";
import { forwardRef } from "react";

const ExpandAnalytics = ({ id, onClickExplore }) => {
	const handleOnClickExplore = () => {
		onClickExplore();
  };

  const ForwardedCapabilityBoundary = forwardRef((props, ref) => (
    <CapabilityBoundary {...props} innerRef={ref} />
  ));

	return (
		<Tooltip title="Explore">
      <ForwardedCapabilityBoundary
				render={(disabled) => (
					<IconButton size="small" onClick={handleOnClickExplore} disabled={disabled}>
						<SearchIcon fontSize="small" />
					</IconButton>
				)}
				capability={CAPABILITIES.ACCESS_ADVANCE_ANALYTICS}
			/>
		</Tooltip>
	);
};

export default ExpandAnalytics;
